import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M42 2.5c.3 0 .5.2.5.5v39c0 .3-.2.5-.5.5H3c-.3 0-.5-.2-.5-.5V3c0-.3.2-.5.5-.5h39M42 0H3C1.3 0 0 1.3 0 3v39c0 1.7 1.3 3 3 3h39c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.7,
			y: 21.2,
			className: "icon-fill-primary",
			width: 41.6,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.2,
			y: 1.7,
			className: "icon-fill-primary",
			width: 2.5,
			height: 41.6
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 11.5c6.1 0 11 4.9 11 11s-4.9 11-11 11-11-4.9-11-11 4.9-11 11-11m0-2.5C15 9 9 15 9 22.5S15 36 22.5 36 36 30 36 22.5 30 9 22.5 9z"
		})
	]
});
export default SvgIcon;
